module.exports = __webpack_public_path__ + "static/img/wydc-01.1a8f4f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wydc-01.svg
// module id = dyHg
// module chunks = 1